/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EstimateLocationView } from '../model/estimateLocationView';
import { GetStockTransferDetailView } from '../model/getStockTransferDetailView';
import { HttpError } from '../model/httpError';
import { SearchStockTransferDetailView } from '../model/searchStockTransferDetailView';
import { StockTransferDetailInsert } from '../model/stockTransferDetailInsert';
import { StockTransferDetailUpdate } from '../model/stockTransferDetailUpdate';
import { StockTransferDetailView } from '../model/stockTransferDetailView';
import { UnitType } from '../model/unitType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class StockTransferDetailsService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Delete a StockTransferDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_stocktransferdetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public stockTransferDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public stockTransferDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public stockTransferDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockTransferDetailsByExternalKeyIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/StockTransferDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a StockTransferDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_stocktransferdetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **TransferIdFKObject:** transferId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetStockTransferDetailView>;
    public stockTransferDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStockTransferDetailView>>;
    public stockTransferDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStockTransferDetailView>>;
    public stockTransferDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockTransferDetailsByExternalKeyIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetStockTransferDetailView>('get',`${this.basePath}/StockTransferDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a StockTransferDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_stocktransferdetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsByExternalKeyIdPut(id: string, body?: StockTransferDetailUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<StockTransferDetailView>>;
    public stockTransferDetailsByExternalKeyIdPut(id: string, body?: StockTransferDetailUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StockTransferDetailView>>>;
    public stockTransferDetailsByExternalKeyIdPut(id: string, body?: StockTransferDetailUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StockTransferDetailView>>>;
    public stockTransferDetailsByExternalKeyIdPut(id: string, body?: StockTransferDetailUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockTransferDetailsByExternalKeyIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<StockTransferDetailView>>('put',`${this.basePath}/StockTransferDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Calculates a number of fields required for display in the transfer screen based upon the unit type selected.
     * @param sourceLocationId Source Location Id
     * @param destinationLocationId Destination Location Id
     * @param stockId 
     * @param unitQtyToTransfer 
     * @param unitType 
     * @param factorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsCalculateValuesGet(sourceLocationId: number, destinationLocationId: number, stockId: number, unitQtyToTransfer: number, unitType: UnitType, factorId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<EstimateLocationView>>;
    public stockTransferDetailsCalculateValuesGet(sourceLocationId: number, destinationLocationId: number, stockId: number, unitQtyToTransfer: number, unitType: UnitType, factorId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EstimateLocationView>>>;
    public stockTransferDetailsCalculateValuesGet(sourceLocationId: number, destinationLocationId: number, stockId: number, unitQtyToTransfer: number, unitType: UnitType, factorId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EstimateLocationView>>>;
    public stockTransferDetailsCalculateValuesGet(sourceLocationId: number, destinationLocationId: number, stockId: number, unitQtyToTransfer: number, unitType: UnitType, factorId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceLocationId === null || sourceLocationId === undefined) {
            throw new Error('Required parameter sourceLocationId was null or undefined when calling stockTransferDetailsCalculateValuesGet.');
        }

        if (destinationLocationId === null || destinationLocationId === undefined) {
            throw new Error('Required parameter destinationLocationId was null or undefined when calling stockTransferDetailsCalculateValuesGet.');
        }

        if (stockId === null || stockId === undefined) {
            throw new Error('Required parameter stockId was null or undefined when calling stockTransferDetailsCalculateValuesGet.');
        }

        if (unitQtyToTransfer === null || unitQtyToTransfer === undefined) {
            throw new Error('Required parameter unitQtyToTransfer was null or undefined when calling stockTransferDetailsCalculateValuesGet.');
        }

        if (unitType === null || unitType === undefined) {
            throw new Error('Required parameter unitType was null or undefined when calling stockTransferDetailsCalculateValuesGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sourceLocationId !== undefined && sourceLocationId !== null) {
            queryParameters = queryParameters.set('sourceLocationId', <any>sourceLocationId);
        }
        if (destinationLocationId !== undefined && destinationLocationId !== null) {
            queryParameters = queryParameters.set('destinationLocationId', <any>destinationLocationId);
        }
        if (stockId !== undefined && stockId !== null) {
            queryParameters = queryParameters.set('stockId', <any>stockId);
        }
        if (unitQtyToTransfer !== undefined && unitQtyToTransfer !== null) {
            queryParameters = queryParameters.set('unitQtyToTransfer', <any>unitQtyToTransfer);
        }
        if (unitType !== undefined && unitType !== null) {
            queryParameters = queryParameters.set('unitType', <any>unitType);
        }
        if (factorId !== undefined && factorId !== null) {
            queryParameters = queryParameters.set('factorId', <any>factorId);
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/html'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<EstimateLocationView>>('get',`${this.basePath}/stockTransferDetails/calculateValues`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for StockTransferDetail objects&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_stocktransferdetails
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates StockTransferDetailsList   - **Stock:** stockId, inventoryCode, name, innersPerOuter, expectedCostPerOuter, lastCost, inners, outers, averageCost  - **StockTransferHeaders:** destinationLocationId, sourceLocationId, processed  FKExternalKeys   - **TransferIdFKObject:** transferId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param group This parameter is used to group results.                         The fieldName can be any of the following: transferId, stockId, factorId.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: transferDetailId, transferId, stockId, destinationQtyInStock, sourceQtyInStock, qtyToTransfer, valueToTransfer, destMax, destMin, destQtyInStkAfter, avgCost, unitQtyToTransfer, factorId.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: transferDetailId, transferId, stockId, destinationQtyInStock, sourceQtyInStock, qtyToTransfer, valueToTransfer, destMax, destMin, destQtyInStkAfter, avgCost, unitQtyToTransfer, factorId.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is transferDetailId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - transferDetailId would sort by updateDateTime ascending and then transferDetailId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param transferDetailId The unique identifier of this record.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the transferDetailId field and returns all available results that match.   You can use &gt;10 to search for all transferDetailIds greater than 10. You can use [1,2,3] to search for transferDetailIds that match either 1, 2 or 3. You can use this parameter multiple times. eg transferDetailId&#x3D;&gt;5&amp; transferDetailId&#x3D;&lt;10 would search for all transferDetailIds between 5 and 10.
     * @param transferId A reference to the primary key in the StockTransferHeaders Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the transferId field and returns all available results that match.   You can use &gt;10 to search for all transferIds greater than 10. You can use [1,2,3] to search for transferIds that match either 1, 2 or 3. You can use this parameter multiple times. eg transferId&#x3D;&gt;5&amp; transferId&#x3D;&lt;10 would search for all transferIds between 5 and 10.
     * @param stockId A reference to the primary key in the Stock Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the stockId field and returns all available results that match.   You can use &gt;10 to search for all stockIds greater than 10. You can use [1,2,3] to search for stockIds that match either 1, 2 or 3. You can use this parameter multiple times. eg stockId&#x3D;&gt;5&amp; stockId&#x3D;&lt;10 would search for all stockIds between 5 and 10.
     * @param destinationQtyInStock &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the destinationQtyInStock field and returns all available results that match.   You can use &gt;10 to search for all destinationQtyInStocks greater than 10. You can use [1,2,3] to search for destinationQtyInStocks that match either 1, 2 or 3. You can use this parameter multiple times. eg destinationQtyInStock&#x3D;&gt;5&amp; destinationQtyInStock&#x3D;&lt;10 would search for all destinationQtyInStocks between 5 and 10.
     * @param sourceQtyInStock &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the sourceQtyInStock field and returns all available results that match.   You can use &gt;10 to search for all sourceQtyInStocks greater than 10. You can use [1,2,3] to search for sourceQtyInStocks that match either 1, 2 or 3. You can use this parameter multiple times. eg sourceQtyInStock&#x3D;&gt;5&amp; sourceQtyInStock&#x3D;&lt;10 would search for all sourceQtyInStocks between 5 and 10.
     * @param qtyToTransfer &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyToTransfer field and returns all available results that match.   You can use &gt;10 to search for all qtyToTransfers greater than 10. You can use [1,2,3] to search for qtyToTransfers that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyToTransfer&#x3D;&gt;5&amp; qtyToTransfer&#x3D;&lt;10 would search for all qtyToTransfers between 5 and 10.
     * @param valueToTransfer &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the valueToTransfer field and returns all available results that match.   You can use &gt;10 to search for all valueToTransfers greater than 10. You can use [1,2,3] to search for valueToTransfers that match either 1, 2 or 3. You can use this parameter multiple times. eg valueToTransfer&#x3D;&gt;5&amp; valueToTransfer&#x3D;&lt;10 would search for all valueToTransfers between 5 and 10.
     * @param destMax &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the destMax field and returns all available results that match.   You can use &gt;10 to search for all destMaxs greater than 10. You can use [1,2,3] to search for destMaxs that match either 1, 2 or 3. You can use this parameter multiple times. eg destMax&#x3D;&gt;5&amp; destMax&#x3D;&lt;10 would search for all destMaxs between 5 and 10.
     * @param destMin &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the destMin field and returns all available results that match.   You can use &gt;10 to search for all destMins greater than 10. You can use [1,2,3] to search for destMins that match either 1, 2 or 3. You can use this parameter multiple times. eg destMin&#x3D;&gt;5&amp; destMin&#x3D;&lt;10 would search for all destMins between 5 and 10.
     * @param destQtyInStkAfter &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the destQtyInStkAfter field and returns all available results that match.   You can use &gt;10 to search for all destQtyInStkAfters greater than 10. You can use [1,2,3] to search for destQtyInStkAfters that match either 1, 2 or 3. You can use this parameter multiple times. eg destQtyInStkAfter&#x3D;&gt;5&amp; destQtyInStkAfter&#x3D;&lt;10 would search for all destQtyInStkAfters between 5 and 10.
     * @param createDateTime The date and time this record was created.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the createDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all createDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for createDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg createDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; createDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all createDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param updateDateTime The last date and time this record was updated.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the updateDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all updateDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for updateDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg updateDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; updateDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all updateDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param lastUpdateByUserId The userId of the last person to modify this record.&lt;br&gt;This parameter searches for the lastUpdateByUserId field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param avgCost &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the avgCost field and returns all available results that match.   You can use &gt;10 to search for all avgCosts greater than 10. You can use [1,2,3] to search for avgCosts that match either 1, 2 or 3. You can use this parameter multiple times. eg avgCost&#x3D;&gt;5&amp; avgCost&#x3D;&lt;10 would search for all avgCosts between 5 and 10.
     * @param unitQtyToTransfer &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the unitQtyToTransfer field and returns all available results that match.   You can use &gt;10 to search for all unitQtyToTransfers greater than 10. You can use [1,2,3] to search for unitQtyToTransfers that match either 1, 2 or 3. You can use this parameter multiple times. eg unitQtyToTransfer&#x3D;&gt;5&amp; unitQtyToTransfer&#x3D;&lt;10 would search for all unitQtyToTransfers between 5 and 10.
     * @param unitType &lt;br&gt;This parameter searches for the unitType field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param factorId A reference to the primary key in the Factors Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the factorId field and returns all available results that match.   You can use &gt;10 to search for all factorIds greater than 10. You can use [1,2,3] to search for factorIds that match either 1, 2 or 3. You can use this parameter multiple times. eg factorId&#x3D;&gt;5&amp; factorId&#x3D;&lt;10 would search for all factorIds between 5 and 10.
     * @param externalKey The unique external key set by the current user accessing the API&lt;br&gt;This parameter searches for the externalKey field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param organisationId Allows an api user to filter results by 1 or more organisationIds. To use multiple organisationIds: organisationId&#x3D;[org1,org2]
     * @param venueId Allows an api user to filter results by 1 or more venueIds. To use multiple organisationIds: venueId&#x3D;[venueId1,venueId2]
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, transferDetailId?: number, transferId?: number, stockId?: number, destinationQtyInStock?: string, sourceQtyInStock?: string, qtyToTransfer?: string, valueToTransfer?: string, destMax?: string, destMin?: string, destQtyInStkAfter?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, avgCost?: string, unitQtyToTransfer?: string, unitType?: string, factorId?: number, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchStockTransferDetailView>;
    public stockTransferDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, transferDetailId?: number, transferId?: number, stockId?: number, destinationQtyInStock?: string, sourceQtyInStock?: string, qtyToTransfer?: string, valueToTransfer?: string, destMax?: string, destMin?: string, destQtyInStkAfter?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, avgCost?: string, unitQtyToTransfer?: string, unitType?: string, factorId?: number, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchStockTransferDetailView>>;
    public stockTransferDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, transferDetailId?: number, transferId?: number, stockId?: number, destinationQtyInStock?: string, sourceQtyInStock?: string, qtyToTransfer?: string, valueToTransfer?: string, destMax?: string, destMin?: string, destQtyInStkAfter?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, avgCost?: string, unitQtyToTransfer?: string, unitType?: string, factorId?: number, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchStockTransferDetailView>>;
    public stockTransferDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, transferDetailId?: number, transferId?: number, stockId?: number, destinationQtyInStock?: string, sourceQtyInStock?: string, qtyToTransfer?: string, valueToTransfer?: string, destMax?: string, destMin?: string, destQtyInStkAfter?: string, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, avgCost?: string, unitQtyToTransfer?: string, unitType?: string, factorId?: number, externalKey?: string, organisationId?: string, venueId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (transferDetailId !== undefined && transferDetailId !== null) {
            queryParameters = queryParameters.set('transferDetailId', <any>transferDetailId);
        }
        if (transferId !== undefined && transferId !== null) {
            queryParameters = queryParameters.set('transferId', <any>transferId);
        }
        if (stockId !== undefined && stockId !== null) {
            queryParameters = queryParameters.set('stockId', <any>stockId);
        }
        if (destinationQtyInStock !== undefined && destinationQtyInStock !== null) {
            queryParameters = queryParameters.set('destinationQtyInStock', <any>destinationQtyInStock);
        }
        if (sourceQtyInStock !== undefined && sourceQtyInStock !== null) {
            queryParameters = queryParameters.set('sourceQtyInStock', <any>sourceQtyInStock);
        }
        if (qtyToTransfer !== undefined && qtyToTransfer !== null) {
            queryParameters = queryParameters.set('qtyToTransfer', <any>qtyToTransfer);
        }
        if (valueToTransfer !== undefined && valueToTransfer !== null) {
            queryParameters = queryParameters.set('valueToTransfer', <any>valueToTransfer);
        }
        if (destMax !== undefined && destMax !== null) {
            queryParameters = queryParameters.set('destMax', <any>destMax);
        }
        if (destMin !== undefined && destMin !== null) {
            queryParameters = queryParameters.set('destMin', <any>destMin);
        }
        if (destQtyInStkAfter !== undefined && destQtyInStkAfter !== null) {
            queryParameters = queryParameters.set('destQtyInStkAfter', <any>destQtyInStkAfter);
        }
        if (createDateTime !== undefined && createDateTime !== null) {
            queryParameters = queryParameters.set('createDateTime', <any>createDateTime);
        }
        if (updateDateTime !== undefined && updateDateTime !== null) {
            queryParameters = queryParameters.set('updateDateTime', <any>updateDateTime);
        }
        if (lastUpdateByUserId !== undefined && lastUpdateByUserId !== null) {
            queryParameters = queryParameters.set('lastUpdateByUserId', <any>lastUpdateByUserId);
        }
        if (avgCost !== undefined && avgCost !== null) {
            queryParameters = queryParameters.set('avgCost', <any>avgCost);
        }
        if (unitQtyToTransfer !== undefined && unitQtyToTransfer !== null) {
            queryParameters = queryParameters.set('unitQtyToTransfer', <any>unitQtyToTransfer);
        }
        if (unitType !== undefined && unitType !== null) {
            queryParameters = queryParameters.set('unitType', <any>unitType);
        }
        if (factorId !== undefined && factorId !== null) {
            queryParameters = queryParameters.set('factorId', <any>factorId);
        }
        if (externalKey !== undefined && externalKey !== null) {
            queryParameters = queryParameters.set('externalKey', <any>externalKey);
        }
        if (organisationId !== undefined && organisationId !== null) {
            queryParameters = queryParameters.set('organisationId', <any>organisationId);
        }
        if (venueId !== undefined && venueId !== null) {
            queryParameters = queryParameters.set('venueId', <any>venueId);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchStockTransferDetailView>('get',`${this.basePath}/StockTransferDetails/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a StockTransferDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_stocktransferdetails
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsIdDelete(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public stockTransferDetailsIdDelete(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public stockTransferDetailsIdDelete(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public stockTransferDetailsIdDelete(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockTransferDetailsIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/StockTransferDetails/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a StockTransferDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_stocktransferdetails
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **TransferIdFKObject:** transferId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetStockTransferDetailView>;
    public stockTransferDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStockTransferDetailView>>;
    public stockTransferDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStockTransferDetailView>>;
    public stockTransferDetailsIdGet(id: number, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockTransferDetailsIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetStockTransferDetailView>('get',`${this.basePath}/StockTransferDetails/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a StockTransferDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_stocktransferdetails
     * @param id Used to identify a specific record by its unique ID
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsIdPut(id: number, body?: StockTransferDetailUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<StockTransferDetailView>>;
    public stockTransferDetailsIdPut(id: number, body?: StockTransferDetailUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StockTransferDetailView>>>;
    public stockTransferDetailsIdPut(id: number, body?: StockTransferDetailUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StockTransferDetailView>>>;
    public stockTransferDetailsIdPut(id: number, body?: StockTransferDetailUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling stockTransferDetailsIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<StockTransferDetailView>>('put',`${this.basePath}/StockTransferDetails/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Creates a new StockTransferDetail&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_stocktransferdetails
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stockTransferDetailsPost(body?: StockTransferDetailInsert, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<StockTransferDetailView>;
    public stockTransferDetailsPost(body?: StockTransferDetailInsert, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StockTransferDetailView>>;
    public stockTransferDetailsPost(body?: StockTransferDetailInsert, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StockTransferDetailView>>;
    public stockTransferDetailsPost(body?: StockTransferDetailInsert, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StockTransferDetailView>('post',`${this.basePath}/StockTransferDetails/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
